.arrow {
  height: 9.6rem;
  width: 9.6rem;
  border-radius: 50%;
  background-color: var(--color-secondary);
  animation: bounce 1.5s ease-in-out infinite;

  svg {
    width: 9.6rem;
    fill: white;
    transform: rotate(-90deg);
  }

  @keyframes bounce {
    0% {
      transform: translateY(-0.2rem);
    }

    50% {
      transform: translateY(0.2rem);
    }

    100% {
      transform: translateY(-0.2rem);
    }
  }
}
